import './app.css';
import 'flowbite';
import './dark-mode';
import './navbar';
import './current-year';